module.exports = __webpack_public_path__ + "img/a6598da.jpg";